export default __webpack_public_path__ + "static/media/17t.f2f2cf40.jpg";